import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { mobileInitialState } from "./mobile.state";

const mobileSlice = createSlice({
  name: "mobile",
  initialState: mobileInitialState,
  reducers: {
    setIsPurePage: (state, action: PayloadAction<boolean>) => {
      state.isPurePage = action.payload;
    },
    setMobileToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    setIsMobileAi: (state, action: PayloadAction<boolean>) => {
      state.isMobileAi = action.payload;
    },
    resetMobile: (state) => {
      state.isPurePage = false;
      state.isMobileAi = false;
      state.token = null;
    },
  },
});

export const { setIsPurePage, setIsMobileAi, setMobileToken, resetMobile } =
  mobileSlice.actions;
export default mobileSlice.reducer;
